import { Image } from 'react-bootstrap'
import styled from 'styled-components'
import imgUser from '../../../images/user.png'
import Container from 'react-bootstrap/Container'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as loginActions from '../../../actions/login.action'
import { FiLogOut } from 'react-icons/fi'
import { MENU_LOGIN } from '../../../router/routes'
import { Dropdown } from 'antd'
import { FOOTER_VERSION } from '../../../Constants'
import {
  useApiVersionStore,
  useIsShowMenuListStore
} from '../../../store/layout'
import { LuMenu } from 'react-icons/lu'
import { useLanguageStage } from '../../../store/layout'

function HeaderPage({ childrenTitle }) {
  const profile = useSelector((state) => state.loginReducer.profile)
  const { setShowMenu } = useIsShowMenuListStore()

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { apiVersion } = useApiVersionStore()
  const fnLogout = () => {
    dispatch(loginActions.logout(navigate, MENU_LOGIN))
    navigate(MENU_LOGIN)
  }

  const items = [
    {
      key: '5',
      label: (
        <div>
          <div>
            <span>WEB: {FOOTER_VERSION}</span>
          </div>
          <div>
            <span>API: {apiVersion}</span>
          </div>
        </div>
      ),
      disabled: true
    },
    {
      key: '1',
      label: (
        <div className="w-100" onClick={fnLogout}>
          <FiLogOut size={20} className="me-2" /> Logout
        </div>
      )
    }
  ]

  const { languageStage, setLanguageStage } = useLanguageStage()

  return (
    <>
      <Container fluid className="d-flex justify-content-between  ps-0 pe-0">
        <div
          className="pointer-event my-auto d-block d-lg-none"
          onClick={() => setShowMenu(true)}
        >
          <LuMenu size={26} />
        </div>

        <div className="my-auto d-flex flex-grow-1" style={{ minWidth: 0 }}>
          {childrenTitle}
        </div>

        {/* Language Switcher */}
        <div className="d-flex align-items-center gap-1 flex-shrink-0">
          <button
            type="button"
            onClick={() => setLanguageStage('en')}
            className="border-0 bg-transparent p-0 fw-bold"
            style={{
              color: languageStage === 'en' ? '#0d6efd' : '#6c757d',
              cursor: 'pointer',
              fontSize: '0.85rem',
              transition: 'color 0.2s'
            }}
          >
            EN
          </button>

          <span className="text-muted" style={{ fontSize: '0.85rem' }}>
            |
          </span>

          <button
            type="button"
            onClick={() => setLanguageStage('th')}
            className="border-0 bg-transparent p-0 fw-bold"
            style={{
              color: languageStage === 'th' ? '#0d6efd' : '#6c757d',
              cursor: 'pointer',
              fontSize: '0.85rem',
              transition: 'color 0.2s'
            }}
          >
            TH
          </button>
        </div>

        <Dropdown menu={{ items }} className="d-flex ">
          <Image
            src={`${profile?.img_url}`}
            fluid
            className="rounded-pill my-auto ms-3"
            style={{
              width: 40,
              height: 40,
              objectFit: 'cover',
              border: '2px solid #ffff',
              cursor: 'pointer'
            }}
            onError={(event) => {
              event.target.src = imgUser
              event.onerror = null
            }}
          />
        </Dropdown>
      </Container>
    </>
  )
}
export const MenuPage = styled.div`
  .MuiDrawer-paper {
    background-color: #7367f0;
    left: unset;
    right: unset;
    overflow-x: hidden;
    transition:
      width 0.25s ease-in-out 0s,
      box-shadow 0.25s ease-in-out 0s;
  }
  .MenuPage {
    flex: 0 0 auto;
    overflow-x: hidden;
    transition: width 0.25s ease-in-out 0s;
    width: 260px;
  }
  @media (max-width: 1200px) {
    .MenuPage {
      width: 0px;
    }
    .MuiDrawer-paper {
      display: none;
    }
  }
`

export const Title = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  text-decoration: none;
`

export const MenuBody = styled.div`
  color: rgba(51, 48, 60, 0.87);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-image: none;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1 0 auto;
  z-index: 100;
  position: fixed;
  top: 0px;
  outline: 0px;
  left: 0px;
  background-color: rgb(255, 255, 255);
  box-shadow:
    rgb(51 48 60 / 3%) 0px 3px 9px 1px,
    rgb(51 48 60 / 2%) 0px 8px 9px 0px,
    rgb(51 48 60 / 1%) 0px 1px 6px 4px;
  width: 260px;
  border-right: 0px solid;
`

export const MenuHeader = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding-right: 1.125rem;
  transition: padding 0.25s ease-in-out 0s;
  min-height: 64px;
  padding-left: 1.125rem;
`

export const MenuContent = styled.div`
  position: relative;
  overflow: hidden;

  .scrollbar-container {
    position: relative;
    height: 100%;
  }
  .ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
  }
`

export const SubMenu = styled.li`
  display: flex;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  align-items: center;
  position: relative;
  text-decoration: none;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  margin-top: 0.25rem;
  flex-direction: column;
  padding-left: 0px !important;
  padding-right: 0px !important;
`
export default HeaderPage
